import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/design.module.scss';
import stylish from 'images/design/stylish.png';
import elegant from 'images/design/elegant.png';
import calm from 'images/design/calm.png';
import beach from 'images/design/beach.png';
import girly from 'images/design/girly.png';
import wamodern from 'images/design/wamodern.png';
import traditional from 'images/design/traditional.png';
import designEditParts from 'images/design/designEditParts.png';
import designEditBackGround from 'images/design/designEditBackGround.png';
import designEditMenu from 'images/design/designEditMenu.png';


const TopView = () => {
  return (
    <section className={Style.design}>
      <div className={Style.design__topView}>
        <div className={Style.design__topView__labelWrapper}>  
          <div className={Style.design__topView__label}>
            かんたん、シンプルな操作で<br />
            あなた好みの見た目に
          </div>
          <div className={Style.design__topView__subLabel}>
            テンプレートを選ぶだけで、統一感のあるショップができあがります。
          </div>
        </div>
        <img className = {classNames(Style.design__topView__img)} src={stylish} alt="" />
      </div>
    </section>
  );
}

const themes = [
  { img: elegant },
  { img: calm },
  { img: beach },
  { img: girly },
  { img: wamodern },
  { img: traditional },
];


const Templetes = () => {
  return (
    <>
      <div className={Style.templetesGrid}>
        {themes.map((theme, index) => (
          <div className={Style.templeteCard} key={index}>
            <img src={theme.img} alt="PC view" className={Style.img} />
          </div>
        ))}
      </div>
      <div className={Style.templeteDescription}>
        全25種類の無料テンプレートをご用意しています！
      </div>
    </>
  );
};

const DesignDescription = () => {
  return (
    <>
      <section className={Style.designDescription}>
        <div className={Style.sectionInner}>
          <h2 className={Style.title}>デザインパーツで、かんたんにカスタマイズ</h2>
          <p className={Style.subTitle}>
            パーツを組み合わせて、オリジナルのショップを作ることができます。
          </p>
          <div className={Style.twoCol}>
            <img src={designEditParts} alt="エディタ画面" className={Style.image} />
          </div>
        </div>
        <div className={Style.sectionInner}>
          <h2 className={Style.title}>
            お店の背景やメニューレイアウトを変更して、<br />
            さらにショップの世界観を表現できます。
          </h2>
          <div className={Style.twoCol}>
            <div className={Style.card}>
              <img src={designEditBackGround} className={Style.cardImage} alt="背景編集画面" />
              <p className={Style.cardTitle}>背景の変更</p>
              <p className={Style.cardContent}>
                ショップのイメージに合わせて、カラーや画像を選んでお店の背景を変更できます。
                背景画像は自身でご用意した画像をアップロードして、背景設定が行えます。
                </p>
            </div>
            <div className={Style.card}>
              <img src={designEditMenu} className={Style.cardImage} alt="メニュー編集画面" />
              <p className={Style.cardTitle}>メニューの変更</p>
              <p className={Style.cardContent}>
                ショップのメニュー表示項目（メニュータイトル）を変更したり、
                メニューレイアウトでメニューの位置を設定することができます。
                ショップの雰囲気に合わせて、文字カラーの変更ができます。
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Design = () => {
  return (
    <section className={Style.design}>
      <TopView />
      <Templetes />
      <DesignDescription />
    </section>
  );
};

export default Design;
